export default __webpack_public_path__ + "static/media/bg-queries.dccd4559.png";